import { Tooltip, styled, tooltipClasses } from "@mui/material"

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.customColors.darkBg,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.customColors.darkBg,
    color: theme.palette.common.white,
    padding: '1rem',
  },
}));

export default BootstrapTooltip
